<script>
    import asyncImage from './asyncImage';

    /**
     * This is a VueJS driven async, and optionally dynamic, background image loader,
     *
     * An image load can be triggered via three methods
     * 1) Via an intersection observer detecting the image scrolling within the actively viewed DOM
     * 2) Via a page resize event
     * 3) If intersection is not available, it will be loaded on initialization
     */
    export default {
        name: 'VueBackgroundImage',

        mixins: [asyncImage],

        computed: {
            style() {
                return this.imageSource ? {
                    'background-image': `url('${this.imageSource}')`
                } : {};
            }
        },
    };
</script>

<template>
    <div v-bind:style="style">
        <slot></slot>
    </div>
</template>